export default {
  loading_menu: 'Se încarcă meniul...',
};
